import { post, get } from "@/utils/api";
import { actions, mutations } from "@/store";
import { trackException } from "@/appInsights";
import { AppNotification } from "@/constants/appNotification";

export default {
  async searchNaturalEntitiesByResourceId({ commit, dispatch }, payload) {
    const { resourceId, query } = payload;
    commit(mutations.screeningDetailsLoadInit);
    try {
      const data = await get(
        `${process.env.VUE_APP_ARBITRIUM_API}/v1/aml-screening/natural-entities/${resourceId}`
      );
      commit(mutations.screeningDetailsSuccess, { details: data });
    } catch (error) {
      trackException({
        exception: error,
        properties: { source: "store/screening/searchNaturalEntitiesByResourceId" }
      });
      commit(mutations.screeningLoadError, { error: error.message, query });
      dispatch(actions.notificationAdd, {
        id: AppNotification.ScreeningLoadError,
        title: "Sanction search failed",
        message: error.message,
        duration: 0,
        actions: [
          { label: "Dismiss" },
          {
            label: "Retry",
            action: actions.searchNaturalEntitiesByResourceId,
            payload
          }
        ]
      });
    }
  },
  async searchNaturalEntities({ commit, dispatch }, payload) {
    const { query } = payload;
    commit(mutations.screeningLoadInit, { query });
    try {
      const data = await post(
        `${process.env.VUE_APP_ARBITRIUM_API}/v1/aml-screening/natural-entities/search`,
        {
          name: query.name,
          birthDate: query.birthDate,
          threshold: query.threshold
        }
      );
      commit(mutations.screeningLoadSuccess, { result: data.data, query });
    } catch (error) {
      trackException({
        exception: error,
        properties: { source: "store/screening/searchNaturalEntities" }
      });
      commit(mutations.screeningLoadError, { error: error.message, query });
      dispatch(actions.notificationAdd, {
        id: AppNotification.ScreeningLoadError,
        title: "Sanction search failed",
        message: error.message,
        duration: 0,
        actions: [
          { label: "Dismiss" },
          { label: "Retry", action: actions.searchNaturalEntities, payload }
        ]
      });
    }
  }
};
